// extracted by mini-css-extract-plugin
export default {"home":"Home_home__i3cmQ","header":"Home_header__FRk3p","singin":"Home_singin__BLCqC","conatiner":"Home_conatiner__GjB4u","title":"Home_title__SSS8S","bgImage":"Home_bgImage__VT3LC"};